import { DramaMasksIcon } from './DramaMasksIcon';

/**
 * author: Augustin Ursu
 * id ACAF4137-3EA8-4B7C-A1DB-C34759C70A5D
 * name drama-masks
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/drama-masks.svg
 * tags
 */
export const TragedyIcon = DramaMasksIcon;
export default TragedyIcon